type CsaBoxCardBodyProps = {
  title: string;
  text: string[];
};

const CsaBoxCardBody = ({ title, text }: CsaBoxCardBodyProps) => {
  const descriptionList = text.map((li, index) => {
    return <li key={li + index}>{li}</li>;
  });
  return (
    <div className="csa-box-card-body">
      <h4>{title}</h4>
      <ul>{descriptionList}</ul>
    </div>
  );
};

export default CsaBoxCardBody;
